import { Icon } from 'shared/ui/Icon'
import { Typography } from 'shared/ui/Typography'
import { WidgetItem } from 'pages/chatbot/ui/UnifiedAgent/ui/Chat/ui/Widgets'
import { ACTION_OPTIONS } from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/store/actionsWidgetStore'
import styles from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/styles.module.scss'

type IActionsStep2Props = {
  focusedIndex: number
  onSelect: (index: number) => void
}

export const ActionsStep2 = ({ focusedIndex, onSelect }: IActionsStep2Props) => (
  <div className={styles.list}>
    {ACTION_OPTIONS.map((action, index) => (
      <WidgetItem
        key={action.key}
        isFocused={index === focusedIndex}
        leftNode={
          <Icon
            icon={action.icon}
            fontSize={20}
            className={styles.actionIcon}
            color='var(--content-brand-primary)'
          />
        }
        onClick={() => onSelect(index)}
      >
        <Typography variant={'body-rg-regular'} ariaLabel={action.label}>
          {action.label}
        </Typography>
      </WidgetItem>
    ))}
  </div>
)
